import * as React from 'react'

import { ErrorMessage } from '@doordash/component-fields'
import Toggle from '@doordash/component-toggle'
import { Text, Inset, StackChildren } from '@doordash/design-language'
import styled from 'styled-components'
import InsuranceTermsModal from './insuranceTermsModal'
import t from './strings'
import { TermsTitle } from './styles'

type Props = {
  onChange: (any) => void
  touched: boolean
  error: string
  id: string
  label: string
  anchorId?: string
}

const BorderInset = styled(Inset)`
  border: ${(props: Props) =>
    props.error ? `1px solid #ff3008` : `1px solid #cccccc`};
  border-radius: 3px;
  margin-top: 4px !important;
`
export class InsuranceCheckBox extends React.Component<Props> {
  public state = {
    value: false,
    showInsuranceModal: false,
  }

  public handleChange = val => {
    this.setState({ value: val })
    this.props.onChange(val)
  }

  public toggleInsuranceModal = () => {
    this.setState({ showInsuranceModal: !this.state.showInsuranceModal })
  }
  public render() {
    const { error, label, id, anchorId } = this.props
    const { showInsuranceModal } = this.state
    return (
      <React.Fragment>
        {showInsuranceModal && (
          <InsuranceTermsModal onClose={this.toggleInsuranceModal} />
        )}
        <StackChildren size={StackChildren.Sizes.Small}>
          <Text
            styles={Text.Styles.TextFieldLabel}
            size={Text.Sizes.S14}
            tag={'label'}
            htmlFor={id}
            lineHeight={Text.LineHeights.S18}
          >
            {label}
          </Text>
          <Toggle
            labelColor={Toggle.LabelColors.Black}
            alignToggle={Toggle.Alignment.Center}
            isSelected={this.state.value}
            onChange={this.handleChange}
            label={label}
            renderLabel={() => (
              <Text size={Text.Sizes.S14} lineHeight={Text.LineHeights.S18}>
                {t.termsLabel()}
                <TermsTitle
                  onClick={() => this.setState({ showInsuranceModal: true })}
                >
                  {t.termsTitle().toLowerCase()}
                </TermsTitle>
              </Text>
            )}
          />
          {error && <ErrorMessage error={error} />}
        </StackChildren>
      </React.Fragment>
    )
  }
}

export default InsuranceCheckBox
